/** @jsxImportSource solid-js */
import { globalState } from "#root/frontend/state.jsx";
import { RecoverySetupForm } from "#root/frontend/components/forms/recoverySetup.solid.js";

/**
 * Show a page for users to enter their account recovery information.
 */
export function Step_4_Recovery(props: {
  currentPhoneNumber: () => string;
  currentEmail: () => string;
  currentUsername: () => string;
  currentPassword: () => string;
  verificationToken: () => string;
  setError: (m: string) => void;
  resetError: () => void;
  goNext: () => void;
}) {
  return (
    <RecoverySetupForm
      goNext={async (
        selectedQuestions: string[],
        givenAnswers: string[],
        consentBroadcast: boolean,
      ) => {
        // TODO: "recovery skip"
        props.resetError();
        await (async () => {
          await globalState.client.createAccount(
            props.currentUsername(),
            props.currentPassword(),
            props.verificationToken(),
            true,
            "", // TODO: how to get campusName here?
            props.currentEmail().split("@")[-1], // TODO: clean this up
          );

          await globalState.client.setUpAccountRecovery(
            consentBroadcast,
            props.currentEmail(),
            props.currentPhoneNumber(),
            selectedQuestions,
            givenAnswers,
          );

          // New users are always tagged as accepting Ampersands, since this will push after that.
          globalState.client.userData.acceptedAmpersands = true;
          await globalState.client.updateConsent("ampersandsApr2026", true);

          // Set a flag on the user account so we can warn them about using their personal email later.
          globalState.client.userData.recoveryPersonalEmailNeeded = true;
          await globalState.client.saveUserData();

          // Explicitly save the privacy policy preference.
          await globalState.client.acceptPrivacyPolicy();

          // Explicitly save the contact information we're given.
          globalState.client.contactInfo.email = props.currentEmail();
          globalState.client.contactInfo.phone = props.currentPhoneNumber();
          await globalState.client.updateContactInfo();

          // XXX: This hack should essentially re-initialize the client to act as though the user
          //      just logged in.
          await globalState.client.bootstrap();
        })()
          .then(() => {
            props.goNext();
          })
          .catch((e) => {
            console.error(e);
            props.setError("We ran into a problem creating your account.");
          });
      }}
    />
  );
}
